<template>
  <div>
    <div class="detail-header">
      <div class="header-main content">
        <div>
          <img src="../../static/img/index/headtitle.png">
        </div>
        <div class="sub-title">“路标式”政务服务事项解读体系</div>
        <img class="gzjz" src="../../static/img/index/gzjz.png">
      </div>
    </div>
    <div class="Topmatter content">
      <div class="listcon">
        <div class="listname">工伤保险住院伙食补助费申领</div>
        <div class="listbutton">
          <a class="reservation "
            href="https://www.gdzwfw.gov.cn/portal/v3/guide/TE44010671818849505442111676001#matters-part4"
            target="_blank">在线预约</a>
          <a class="guide "
            @click="openWechat('https://www.gdzwfw.gov.cn/portal/v3/guide/TE44010671818849505442111676001#matters-part4')">办事指南</a>
        </div>
      </div>
      <div class="ewm">
        <img src="../../static/img/details/QRcode/yytx11.png">
        <div>使用微信扫码登录</div>
      </div>
    </div>
    <div style="background: #FAFAFB">
      <!--办事解读-->
      <div class="Bsjd content" id="bsjd">
        <div class="conTitle detailConTitle1"><img src="../../static/img/details/detailTitle-lbsjd.png"></div>
        <div class="left-right">
          <div class="bsjdMain">
            <div class="swiper img-swiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <img src="../../static/img/details/yytx11.png" alt=""
                    @click="openWechat('https://mp.weixin.qq.com/s?__biz=MzA4NTUxNzY4MQ==&mid=2650329032&idx=8&sn=90aedb61050c8a60911e6a22d6aa5668&scene=21#wechat_redirect')">
                  <img class="go-detail" src="../../static/img/details/godetail.gif"
                    @click="openWechat('https://mp.weixin.qq.com/s?__biz=MzA4NTUxNzY4MQ==&mid=2650329032&idx=8&sn=90aedb61050c8a60911e6a22d6aa5668&scene=21#wechat_redirect')">
                </div>
              </div>
              <!-- <div class="swiper-button-next-img swiper-button-next3"></div>
              <div class="swiper-button-prev-img swiper-button-prev3"></div> -->
            </div>
          </div>
          <div class="bsjd-table">
            <div class="bsjd-body">
              <div class="title">文件依据</div>
              <div class="bsjd-item">
                <div><a target="_blank"
                    href="https://www.gd.gov.cn/zwgk/wjk/zcfgk/content/post_2722109.html">社会保险基金先行支付暂行办法</a>
                </div>
                <div>2025-04-27</div>
              </div>
              <div class="bsjd-item">
                <div><a target="_blank"
                    href="https://www.gd.gov.cn/zwgk/wjk/zcfgk/content/post_2520662.html">中华人民共和国社会保险法</a>
                </div>
                <div>2025-04-27</div>
              </div>
              <div class="bsjd-item">
                <div><a target="_blank"
                    href="https://www.gd.gov.cn/zwgk/wjk/zcfgk/content/post_2532060.html">工伤保险条例（2010年修正本）</a>
                </div>
                <div>2025-04-27</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <!--智能引导-->
      <div class="Znyd content" id="znyd">
        <div class="conTitle detailConTitle"><img src="../../static/img/details/detailTitle-cjsdb.png"></div>
        <div class="znydMain">
          <div class="yd-qx">
            <div class="title-h" style="display: flex">
              <div class="image-c">
                <img src="../../static/img/intelligent/robort.png" alt="">
              </div>
              <div class="title">选择办事情形</div>
            </div>
            <div class="yd-qx-list" v-for="(item1, index1) in daoBanList">
              <div class="guide-icon guide-icon-active"></div>
              <div class="guide-line-top" v-if="index1"></div>
              <div class="guide-line-bottom" v-else></div>
              <div class="qx-rom">
                <div class="romtit">{{ item1.title }}</div>
                <div class="btn-group">
                  <div :class='item2.xuanzhong ? "btn1 active1" : "btn1"' v-for="(item2, index2) in item1.values"
                    @click="daobanItemChoose(index1, index2)">
                    {{ item2.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right-cl">
            <div class="clMain">
              <div class="cltitle">需要提供的材料</div>
              <div class="cltable">
                <div class="tablehead">
                  <span class="clname">申请材料名称</span>
                  <span class="clzt">材料要求</span>
                </div>
                <ul>
                  <li v-for="(item, index) in cailiaoList">
                    <div class="clname">{{ item.name }}</div>
                    <div class="clzt">{{ item.state }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!--一地图-->
      <div class="content hall" id="dtdh">
        <div class="conTitle detailConTitle"><img src="../../static/img/details/detailTitle-dtdh.png"></div>
        <div class="mapContanier" style="padding-top: 0px; padding-bottom: 24px">
          <iframe src="https://thzwb.thnet.gov.cn/icity_pc/#/index" frameborder="0" width="100%" height="1000"></iframe>
        </div>
      </div>
    </div>

    <!--高频事项-->
    <div class="Frequency" id="gpsx">
      <div class="content">
        <div class="conTitle"><img src="../../static/img/details/detailTitle5.png"></div>
        <div class="freMain">
          <ul>
            <li><a alt="" @click="openWechat('https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise2')">
                <img src="../../static/img/details/gp-icon1.png">
                <div>内资有限责任公司设立登记</div>
              </a></li>
            <li><a alt="" @click="openWechat('https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise3')">
                <img src="../../static/img/details/gp-icon1.png">
                <div>内资有限责任公司变更登记</div>
              </a></li>
            <li><a alt="" @click="openWechat('https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise5')">
                <img src="../../static/img/details/gp-icon2.png">
                <div>企业注册登记档案查询</div>
              </a></li>
            <li><a alt="" @click="openWechat('https://thzwb.thnet.gov.cn/yytx/#/SearchDetailOperate2')">
                <img src="../../static/img/details/gp-icon3.png">
                <div>公共场所卫生许可（新证，含改、扩建)</div>
              </a></li>
            <li><a alt="" @click="openWechat('https://thzwb.thnet.gov.cn/yytx/#/SearchDetailOperate4')">
                <img src="../../static/img/details/gp-icon2.png">
                <div>公众聚集场所投入使用、营业前消防安全检查（告知承诺件）</div>
              </a></li>
          </ul>
        </div>
      </div>
    </div>

    <!--  左侧导航栏-->
    <div class="Leftnav">
      <ul>
        <li :class="[isInArea1 ? 'Lactive' : '']" @click="scrollToArea(1)"><a>路标式解读</a></li>
        <li :class="[isInArea2 ? 'Lactive' : '']" @click="scrollToArea(2)"><a>场景式导办</a></li>
        <li :class="[isInArea3 ? 'Lactive' : '']" @click="scrollToArea(3)"><a>地图导航</a></li>
        <li :class="[isInArea4 ? 'Lactive' : '']" @click="scrollToArea(4)"><a>高频事项</a></li>
      </ul>
    </div>
  </div>
</template>

<style>
@import "../../static/css/bootstrap-icons.css";
@import "../../static/css/bootstrap.min.css";
@import "../../static/css/common.css";
@import "../../static/css/global.css";
@import "../../static/css/details.css";
</style>

<script src="../../static/js/jquery.min.js"></script>
<!-- Page -->
<script src="../../static/js/index.js"></script>
<script>
function setContentTab(name, curr, n) {
  for (i = 1; i <= n; i++) {
    var menu = document.getElementById(name + i);
    var cont = document.getElementById("con_" + name + "_" + i);
    menu.className = i == curr ? "LiActive" : "";
    if (i == curr) {
      cont.style.display = "block";
    } else {
      cont.style.display = "none";
    }
  }
}
</script>
<script>
import detailJson from "../../static/js/situation/yytx11.json"
export default {
  name: "yytx11",

  data() {
    return {
      daoBanList: detailJson.yytx11.daobanList,
      cailiaoList: [],
      isInArea1: true,
      isInArea2: false,
      isInArea3: false,
      isInArea4: false,
      key: "",
    }
  },
  mounted() {
    this.daobanItemChoose(0, 0)
    console.log(this.isInArea3)
    window.addEventListener("scroll", this.handleScroll)
  },

  methods: {
    daobanItemChoose(index1, index2) {
      console.log(index1, index2)
      var daobanList = this.daoBanList
      for (let i = 0; i < this.daoBanList.length; i++) {
        if (i == index1) {
          var daoban = this.daoBanList[i]
          for (let j = 0; j < daoban.values.length; j++) {
            if (j == index2) {
              daobanList[i].values[j].xuanzhong = 1
            } else {
              daobanList[i].values[j].xuanzhong = 0
            }
          }
          break
        }
      }
      this.daoBanList = daobanList
      var cailiaoList = []
      for (let i = 0; i < daobanList.length; i++) {
        var daoban = daobanList[i]
        for (let j = 0; j < daoban.values.length; j++) {
          var caliao = daoban.values[j]
          if (caliao.xuanzhong) {
            caliao.cailiaoList.forEach((item) => {
              cailiaoList.push(item)
            })
          }
        }
      }
      this.cailiaoList = cailiaoList
    },
    openSearch() {
    },
    scrollToArea(index) {
      var scale = document.documentElement.clientWidth / 1920; // 分母——设计稿的尺寸
      var e1 = document.getElementById('bsjd').offsetTop *scale;
      var e2 = document.getElementById('znyd').offsetTop *scale;
      var e3 = document.getElementById('dtdh').offsetTop *scale;
      var e4 = document.getElementById('gpsx').offsetTop *scale;
      console.log(e1);
      console.log(e2);
      console.log(e3);
      console.log(e4);
      console.log("///////////");
      var scrollY = index == 1 ? e1 : index == 2 ? e2 : index == 3 ? e3 : index == 4 ? e4 : 0
      var options = {
        "top": scrollY,
        "left": 0,
        "behavior": "smooth"
      }
      window.scrollTo(options);
    },

    handleScroll() {
      const scrollTop = this.getScroll().top;
      console.log(scrollTop)
      this.isInArea1 = false;
      this.isInArea2 = false;
      this.isInArea3 = false;
      this.isInArea4 = false;
      var scale = document.documentElement.clientWidth / 1920; // 分母——设计稿的尺寸
      var e1 = document.getElementById('bsjd').offsetTop *scale;
      var e2 = document.getElementById('znyd').offsetTop *scale;
      var e3 = document.getElementById('dtdh').offsetTop *scale;
      var e4 = document.getElementById('gpsx').offsetTop *scale;
      if (scrollTop < e2-10) {
        this.isInArea1 = true;
      } else if (scrollTop < e3-10) {
        this.isInArea2 = true;
      } else if (scrollTop < e4-300) {
        this.isInArea3 = true;
      }else  {
        this.isInArea4 = true;
      }
    },

    //获得页面向左、向上卷动的距离
    getScroll() {
      return {
        left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
        top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      };
    },
    openNewPage(url) {
      window.open(url)
    },
    openWechat(url) {
      window.open(url)
    },
    openExplain() {
      let routeData = this.$router.resolve({
        name: 'explain',
      });
      window.open(routeData.href, '_blank')
    },
  }
}
</script>


// WEBPACK FOOTER //
// SearchDetailCredit15.vue?5e2a3ea6